import React, { useState, useEffect } from 'react';
import { getNews } from '../api';
import { Link } from 'react-router-dom';
import '../styles/NewsArchive.css';

const NewsArchive = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNews(100, 0, true)
      .then(data => {
        setNews(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return `http://localhost:5000${path}`;
  };

  if (loading) return <div className="archive-loading">Загрузка архива...</div>;

  return (
    <div className="archive-page">
      <div className="container">
        <h1 className="archive-title">Архив новостей</h1>
        {news.length === 0 && <p className="archive-empty">В архиве пока нет новостей.</p>}
        <div className="archive-grid">
          {news.map(item => (
            <article key={item.id} className="archive-card">
              {item.mainImage && (
                <div className="archive-card-image">
                  <img src={getImageUrl(item.mainImage)} alt={item.title} />
                </div>
              )}
              <div className="archive-card-content">
                <h2>{item.title}</h2>
                <div className="archive-date">{new Date(item.date).toLocaleDateString('ru-RU')}</div>
                <p>{item.excerpt}</p>
                <Link to={`/news/${item.id}`} className="archive-read-more">
                  Читать подробнее →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsArchive;